export const addZero = (number: number) => {
  return number > 9 ? String(number) : '0' + number
}
